export default {
  FroalaEditorKey: 'ZF3I3C2A6A7A6cD3F3H3D2G3A4B4B6B2E1vDIJ1QCYRWd1GPIb2a1E1==',
}
